module.exports = __webpack_public_path__ + "static/about-content-2-4b595ad5aedde22dfd8a2d95ce5d76b0.png";